import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";

export type ContactFiltersMessages = FiltersMessages & {
  // Filter Labels
  firstNameLabel: string;
  emailLabel: string;
  mobilePhoneLabel: string;
  activeLabel: string;
  cityLabel: string;
  stateLabel: string;
  consentLabel: string;
  statusTrueOption: string;
  statusFalseOption: string;
  selectStatusPlaceholder: string;
  consentAllOption: string;
  consentCompletedOption: string;
  consentCanceledOption: string;
  consentNotCompletedOption: string;
  consentPendingOption: string;
  clearFilterButton: string;
  filterButton: string;
  moreFiltersButton: string;
  lessFiltersButton: string;
};

export const CONTACTS_FILTER_MESSAGES: ContactFiltersMessages = {
  ...FILTER_MESSAGES,

  // Labels
  firstNameLabel: "Nome",
  emailLabel: "Email",
  mobilePhoneLabel: "Celular",
  activeLabel: "Ativo",
  cityLabel: "Cidade",
  stateLabel: "Estado",
  consentLabel: "Consentimento",
  statusTrueOption: "Sim",
  statusFalseOption: "Não",
  selectStatusPlaceholder: "Todos",
  consentAllOption: "Todos",
  consentCompletedOption: "Concedido",
  consentCanceledOption: "Cancelado",
  consentNotCompletedOption: "Não concedido",
  consentPendingOption: "Pendente",
  clearFilterButton: "Limpar filtros",
  filterButton: "Filtrar",
  moreFiltersButton: "Mais filtros",
  lessFiltersButton: "Menos filtros",
};
